export default __webpack_public_path__ + "static/media/USAA Dark.77bf5352.svg";